import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';

export type ListEmptyStateProps = {
  icon?: React.ReactNode;
  title: string;
  hint?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
};

export const ListEmptyState: React.FC<ListEmptyStateProps> = ({
  icon,
  title,
  hint,
  action,
  className,
}) => {
  const { colors } = useTheme();

  return (
    <div className={cn('flex flex-1 flex-col items-center justify-center px-6 py-16 text-center', className)}>
      {icon != null && (
        <div className={cn('mb-4 mx-auto h-12 w-12', colors.textMuted)}>
          {icon}
        </div>
      )}
      <h2 className={cn('text-base font-semibold', colors.text)}>{title}</h2>
      {hint != null && (
        <p className={cn('mt-1 max-w-sm text-sm', colors.textMuted)}>{hint}</p>
      )}
      {action != null && <div className="mt-5">{action}</div>}
    </div>
  );
};
